import { AVAILABLE_LOCALES, AvailableLocale } from '@/config/constants'
import { configure } from '@/generated/routes'

export const setDefaultLocaleParam = (localeParam?: AvailableLocale | null) => {
  configure({
    default_url_options: { locale: localeParam || getLocaleParamFromUrl() },
  })
}

export const getLocaleParamFromUrl = (): AvailableLocale | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const segment = window.location.pathname.slice(1).split('/')[0] as AvailableLocale

  return AVAILABLE_LOCALES.includes(segment) ? segment : null
}

export const withoutLocaleParam = (url: string) => {
  AVAILABLE_LOCALES.some(locale => {
    if (url.startsWith(`/${locale}`)) {
      url = url.replace(`/${locale}`, '')
      return true
    }

    return false
  })

  return url || '/'
}

setDefaultLocaleParam()

export * from '@/generated/routes'
